var __jsx = React.createElement;
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSession } from '@/_MiniApps/auth/AuthContext';
import useCookieClient from '@hooks/useCookieClient';
import { useLocation } from 'react-router-dom';
// Create context
var ClarityContext = /*#__PURE__*/createContext(undefined);

// Provider component

export var ClarityProvider = function ClarityProvider(_ref) {
  var children = _ref.children,
    _ref$clarityProjectId = _ref.clarityProjectId,
    clarityProjectId = _ref$clarityProjectId === void 0 ? process.env.CLARITY_KEY : _ref$clarityProjectId;
  var _useState = useState(false),
    isInitialized = _useState[0],
    setIsInitialized = _useState[1];
  var _useSession = useSession(),
    user = _useSession.user;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var location = useLocation();

  // Initialize Clarity when it's available
  useEffect(function () {
    if (typeof window === 'undefined') return;

    // Wait for Clarity to load (script is loaded via renderer)
    var checkClarity = setInterval(function () {
      if (window.clarity) {
        clearInterval(checkClarity);
        setIsInitialized(true);

        // Set initial consent
        window.clarity('consent', true);
      }
    }, 100);

    // Cleanup timeout
    var timeout = setTimeout(function () {
      clearInterval(checkClarity);
    }, 10000);
    return function () {
      clearInterval(checkClarity);
      clearTimeout(timeout);
    };
  }, []);

  // Send automatic data to Clarity
  var sendAutomaticData = function sendAutomaticData() {
    if (!window.clarity) return;
    var deviceId = getCookieClient("UUID");
    var sessionId = getCookieClient('visitId');

    // Send data to Clarity
    window.clarity('set', 'device_id', deviceId);
    window.clarity('set', 'session_id', sessionId);
    window.clarity('set', 'pageURL', window.location.href);
    window.clarity('set', 'timestamp', new Date().toISOString());
    window.clarity('set', 'browser_info', navigator.userAgent);

    // Identify user if logged in
    if (user !== null && user !== void 0 && user.id) {
      var _user$id;
      window.clarity('identify', user.id.toString());
      window.clarity('set', 'user_Id', user === null || user === void 0 ? void 0 : (_user$id = user.id) === null || _user$id === void 0 ? void 0 : _user$id.toString());
    }
  };

  // Automatically track page views when location changes
  useEffect(function () {
    if (isInitialized) {
      sendAutomaticData();
    }
  }, [location, isInitialized]);
  var contextValue = {
    isInitialized: isInitialized
  };
  return /*#__PURE__*/React.createElement(ClarityContext.Provider, {
    value: contextValue
  }, children);
};

// Hook to use Clarity context
export var useClarity = function useClarity() {
  var context = useContext(ClarityContext);
  if (context === undefined) {
    throw new Error('useClarity must be used within a ClarityProvider');
  }
  return context;
};

// Extend window interface for TypeScript

export default ClarityContext;